import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-profile-shell',
  templateUrl: './profile-shell.component.html',
  styleUrls: ['./profile-shell.component.scss']
})
export class ProfileShellComponent implements OnInit {

  constructor(
    private route: ActivatedRoute
  ) { }

  public url = '';

  ngOnInit() {
    this.setUrl();
  }

  ngOnChange() {
    this.setUrl();
  }

  setUrl() {
    this.url = this.route.snapshot['_routerState'].url;
    console.log(this.url);
  }

}
